<template>
  <div id="questCollapseContainer">
    <b-button class="btnCollapse" :class="visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'" @click="visible = !visible">
      <div>{{ title }}</div>
      <div><b-icon :icon="!visible ? 'chevron-down' : 'chevron-up'" aria-hidden="true"></b-icon></div>
    </b-button>
    <b-collapse v-model="visible" class="m-1 collapseContent">
      <div>{{ content }}</div>
    </b-collapse>
  </div>
</template>
<script>
export default {
  props: ["title","content"],
  data() {
    return {
      visible: false,
    };
  },
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#questCollapseContainer {
    margin-bottom: 15px;
  .btnCollapse {
    width: 100%;
    background: $bg_color_bl 0% 0% no-repeat padding-box;
    border-radius: 20px;
    opacity: 1;
    border: none;
    display: flex;
    justify-content: space-between;
    padding: 15px;
    text-align: left;
  }
  .collapseContent {
    width: 100%;
    background: $bg_color_bl 0% 0% no-repeat padding-box;
    border-radius: 20px;
    opacity: 1;
    border: none;
    display: flex;
    justify-content: space-between;
    padding: 15px;
  }
}
</style>
